<app-page-title [title]="'MENU.HOME_CONTROLLER' | translate" [breadcrumbItems]="breadCrumbItems"/>
